'use client';
import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { dealPath, imageLoader } from '@/utils';

interface IProps {
  name: string;
  iconPath: string;
  darkIconPath: string;
  active: boolean;
}

/**
 * A React component that renders a category item with an icon and name for PC view.
 * 
 * @param props - The component props
 * @param props.name - The name of the category
 * @param props.iconPath - The path to the default icon image
 * @param props.darkIconPath - The path to the icon image used when active
 * @param props.active - Boolean indicating if the category is currently active
 * 
 * @returns A Link component containing the category item with icon and name
 */
export default function PcCategoryItem(props: IProps) {
  const { name, iconPath, darkIconPath, active } = props;
  return (
    <Link href={`/home/${dealPath(name)}/All/1`}>
      <div className={` flex flex-col w-[176px] mr-2 px-[30px] py-5 h-[130px] items-center justify-center rounded-[10px] ${active ? 'bg-[#F3F5FA] text-[#0032B3]' : 'bg-[#FAFAFA]'}`}>
        <Image
          style={{
            objectFit: 'contain',
          }} alt={name}
          src={active ? iconPath : darkIconPath}
          width={46}
          height={46}
          loader={imageLoader}
        />
        <p className='text-center font-medium text-[15px] leading-5'>{ name }</p>
      </div>
    </Link>
  );
}
